
import Navbar from "./navbar";
import Topbar from "./topbar";
import Footer from "./footer";
import Admin from "./admin";

function AdminPage(){
    return(
        <> 
          <Admin/>
         <Footer/>
        </>
    );
}
export default AdminPage;